<template>
  <div class="d-flex pdt-24 pdb-23 pdl-24 pdr-24 align-items-center" v-if="myStatus=='RANKING'">
      <div class="mgr-20 d-flex align-items-start pdt-7  min-w-44 justify-content-center" v-if="leaderList.rank=='1'">
          <img src="images/badge1.png" alt="" class="w-27">
      </div>
      <div class="mgr-20 d-flex align-items-start pdt-7  min-w-44 justify-content-center" v-else-if="leaderList.rank=='2'">
          <img src="images/badge2.png" alt="" class="w-27">
      </div>
      <div class="mgr-20 d-flex align-items-start pdt-7  min-w-44 justify-content-center" v-else-if="leaderList.rank=='3'">
          <img src="images/badge3.png" alt="" class="w-27">
      </div>
      <div class="mgr-20 d-flex align-items-start pdt-7  min-w-44 justify-content-center" v-else>
          <div class="t-color-iconInactive font-m t-headline7 min-w-44 t-center l-spacing66 ">{{ leaderList.rank }}</div>
      </div>
      <div v-if="leaderList.profile && leaderList.profile.file && leaderList.profile.file.resourceUri">
          <UserImgProfile :allData="leaderList" :data="leaderList" :size="'s'" />
      </div>
      <div v-else v-html="getFirstLetter(leaderList.name)" :style="getRandomColor()" class="circle w-40 h-40 user-name-profile"></div>
      <div class="d-flex flex-column pdl-20 flex-grow-1 pdr-16">
          <div class="t-body1 font-r l-spacing48">{{ leaderList.name ? $t('3437',{first: leaderList.name.first, last: leaderList.name.last}):'' }}</div>
          <div class="t-body2 font-m t-color-bodyBlueGray pdt-3">{{ $t('786') }} {{ leaderList.level }}</div>
      </div>
      <div class="d-flex  justify-content-end min-w-100">
          <span class="leader-p t-color-whiteHigh t-caption mgr-4 font-b">P</span>
          <span class="t-subtitle2 font-b">{{ leaderList.point }}</span>
      </div>
  </div>
  <div class="d-flex pdt-19 pdb-19 pdl-24 pdr-24 " v-else>
      <div class="mgr-24 d-flex align-items-start  min-w-44 justify-content-center" v-if="leaderList.rank=='1'">
          <img src="images/badge1.png" alt="" class="w-27">
      </div>
      <div class="mgr-20 d-flex align-items-start   min-w-44 justify-content-center" v-else-if="leaderList.rank=='2'">
          <img src="images/badge2.png" alt="" class="w-27">
      </div>
      <div class="mgr-20 d-flex align-items-start   min-w-44 justify-content-center" v-else-if="leaderList.rank=='3'">
          <img src="images/badge3.png" alt="" class="w-27">
      </div>
      <div class="mgr-20 d-flex align-items-start   min-w-44 justify-content-center" v-else>
          <div class="t-color-iconInactive font-m t-headline7 min-w-44 t-center l-spacing66 ">{{ leaderList.rank }}</div>
      </div>
    <div class="d-flex flex-column flex-grow-1 pdr-16 justify-content-center">
        <div class="t-body1 font-r l-spacing48">{{ leaderList.name ? leaderList.name:'' }}</div>
        <!-- <div class="t-body2 font-m t-color-bodyBlueGray pdt-3">LEVEL 5</div> -->
    </div>
    <div class="d-flex align-items-center  justify-content-end min-w-100">
        <span class="leader-p t-color-whiteHigh t-caption mgr-4 font-b">P</span>
        <span class="t-subtitle2 font-b">{{ leaderList.point }}</span>
    </div>
</div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */
export default {
  components: {
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue")
  },
  props: ["leaderList","myStatus"],
  data() {
    return {
      learnProgressRate: {},
    };
  },
    methods: {
    // 학습진행율 데이터 (get learning status data)
    getFirstLetter(name) {
      let firstCharOfName = name.fullName.trim().slice(0,1);
      return firstCharOfName;
    },
      
    getRandomColor(){
        let colors = ['#fb6262', '#d16443d4', '#4d9fd6', '#40bca7', '#9db82f','#76a0d6', '#a967d4', '#696481', '#4c438d', '#fe7947'];
        let randomColor = colors[Math.floor(Math.random() * colors.length)];
        return `background-color:${randomColor}`
    },
  },
};
</script>

<style scoped>

.t-color-textField2 {
  color:var(--Iconinactive);
}
.t-color-textField1 {
  color: var(--Textfeildactive);
}
.bg-textField2 {
  background-color: var(--Iconinactive);
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}
.nav-extended .brand-logo {
  font-size: 20px;
}
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: var(--SecondaryBtn);
  outline: none;
}

.header-card {
  height: 120px !important;
}
.leader-list-wrapper:not(:last-child) .listItems {
  border-bottom: 1px solid var(--Divider);
}

.rank {
  min-width: 82px;
}
.ranktab2 {
  min-width: 46px;
}

.level-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 28px;
  overflow: hidden;
}

.slIcon {
  width: 34px;
}
.slIcon img {
  width: 27px;
}
.userListIcon {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.userListIcon img {
  width: 40px;
}

.listContent p:first-child {
  font-size: 16px;
}
.listPointIcon {
  width: 19px;
  min-width: 19px;
  height: 19px;
  border-radius: 50%;
}
.levelHeading .listPointIcon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: 500;
}

@media (max-width: 480px) {
  .listContent {
    margin-right: auto;
    /* max-width:100px !important; */
  }
  html[dir="rtl"] .listContent {
    margin-left: auto;
  }
}
.listItems_store .slIcon{min-width: 94px; width: 94px;}
.listItems_store .levelHeading{padding-top: 4px;}
</style>